// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/common/Cards/ApplicationCard/ApplicationCard.css
// module id = 892
// module chunks = 0